import forEach from 'lodash/forEach';
import isObject from 'lodash/isObject';
import debug from 'debug';
const warn = debug('core:URL:warn');
function euc(s) {
    return encodeURIComponent(s).replace(/%2C/g, ',');
}
function _serializeBoolean(keyName, value, structure) {
    return value ? [{ key: encodeURIComponent(keyName), value: '1' }] : [];
}
function _serializeNumber(keyName, value, structure) {
    return [{ key: encodeURIComponent(keyName), value: encodeURIComponent(value) }];
}
function _serializeString(keyName, value, structure) {
    return [{ key: encodeURIComponent(keyName), value: encodeURIComponent(value) }];
}
function _serializeArray(keyName, values, structure) {
    if (typeof values === 'string')
        values = values.split(',');
    if (values == null)
        return [];
    if (!values.length)
        return [];
    //                                                       
    return [{ key: keyName, value: values.map(encodeURIComponent).join(',') }];
}
function _serializeHash(keyName, value, structure) {
    let result = [];
    for (const subkey in structure)
        if (structure.hasOwnProperty(subkey) && value.hasOwnProperty(subkey)) {
            let arr = _serialize(subkey, value[subkey], structure[subkey]);
            if (keyName) {
                arr = arr.map(item => ({
                    key: encodeURIComponent(keyName) + '.' + item.key,
                    value: item.value,
                }));
            }
            result = result.concat(arr);
        }
    return result;
}
function _serialize(keyName, value, structure) {
    if (value == null)
        return [];
    else if (structure === Boolean)
        return _serializeBoolean(keyName, value, structure);
    else if (structure === Number)
        return _serializeNumber(keyName, value, structure);
    else if (structure === String)
        return _serializeString(keyName, value, structure);
    else if (Array.isArray(structure))
        return _serializeArray(keyName, value, structure);
    else if (isObject(structure))
        return _serializeHash(keyName, value, structure);
    return [];
}
//
//                                    
//
function _deserializeBoolean(str, structure) {
    return str === '1' || str === 'true';
}
function _deserializeString(str, structure) {
    return str || null;
}
function _deserializeNumber(str, structure) {
    const value = parseFloat(str);
    return !isNaN(value) ? value : null;
}
function _deserializeArray(str, type) {
    return str
        .split(',')
        .map(val => _deserializeValue(val, type[0]))
        .filter(v => v != null);
}
function _deserializeValue(str, type) {
    if (type === Boolean)
        return _deserializeBoolean(str, type);
    else if (type === Number)
        return _deserializeNumber(str, type);
    else if (type === String)
        return _deserializeString(str, type);
    else if (Array.isArray(type))
        return _deserializeArray(str, type);
    //                                                                                                
    return null;
}
function filterHash(h, fn) {
    const r = {};
    forEach(h, (v, k) => {
        if (fn(k, v))
            r[k] = v;
    });
    return r;
}
function mapHashKeys(h, fn) {
    const r = {};
    forEach(h, (v, k) => (r[fn(k, v)] = v));
    return r;
}
//                                                 
function isHash(h) {
    return isObject(h) && !Array.isArray(h) && typeof h !== 'function';
}
function _deserialize(structure, q) {
    const result = {};
    //                 
    forEach(q, (value, key) => {
        if (!(key.split('.')[0] in structure)) {
            result[key] = value;
        }
    });
    //               
    forEach(structure, (type, sKey) => {
        if (isHash(type)) {
            const fh = filterHash(q, (k, v) => k.indexOf(sKey + '.') === 0);
            result[sKey] = _deserialize(type, mapHashKeys(fh, (k, v) => k.substr(sKey.length + 1)));
        }
        else {
            result[sKey] = _deserializeValue(q[sKey] || '', type);
        }
    });
    return result;
}
const DIGITS = '𝟎𝟏𝟐𝟑𝟒𝟓𝟔𝟕𝟖𝟗';
export default class UrlSerializable {
    _structure;
    constructor(structure) {
        this._structure = structure;
    }
    //                                                           
    //                        
    serializeSearch(urlObject) {
        const urlItems = _serialize('', urlObject, this._structure);
        //                      
        for (const key in urlObject) {
            if (urlObject.hasOwnProperty(key) && !(key in this._structure)) {
                const value = urlObject[key];
                if (key === 'f' && typeof value === 'object') {
                    //                                                           
                    Object.keys(value).forEach(kk => {
                        const vv = value[kk];
                        if (Array.isArray(vv)) {
                            if (vv[0] === '=' || vv[0] === '!=') {
                                urlItems.push({
                                    key: `f.${kk}`,
                                    op: vv[0],
                                    value: vv
                                        .slice(1)
                                        .map(encodeURIComponent)
                                        .join(','),
                                });
                            }
                            else if (vv[0] === 'between' && vv.length === 3) {
                                urlItems.push({ key: `f.${kk}`, op: '=', value: `${encodeURIComponent(vv[1])}..${encodeURIComponent(vv[2])}` });
                            }
                            else {
                                warn('URL: cannot serialize entry', kk, vv);
                            }
                        }
                    });
                }
                else if (value === undefined || value === null) {
                    //
                }
                else if (typeof value === 'string' || typeof value === 'number') {
                    urlItems.push({ key: euc(key), value: euc(urlObject[key]) });
                }
                else if (typeof value === 'boolean') {
                    //     
                }
                else {
                    //                  
                }
            }
        }
        const result = urlItems.map((item) => item.key + (item.op || '=') + item.value).join('&');
        return result;
    }
    _parseFilterExpression(q) {
        const maybeNumber = (v) => {
            if (decodeURIComponent(v).match(/^[𝟎𝟏𝟐𝟑𝟒𝟓𝟔𝟕𝟖𝟗]+$/)) {
                //           
                return +decodeURIComponent(v).replace(/\uD835./g, c => ({ '𝟎': 0, '𝟏': 1, '𝟐': 2, '𝟑': 3, '𝟒': 4, '𝟓': 5, '𝟔': 6, '𝟕': 7, '𝟖': 8, '𝟗': 9 }[c] || ''));
            }
            if (!isNaN(v) && String(+v) === v)
                return +v;
            return decodeURIComponent(v);
        };
        let match = q.match(/^f\.(\w+)(=|!=)(.*)?$/);
        if (match) {
            let [_, key, op, value] = match;
            if (!value) {
                value = [op];
            }
            else if (value.match(/^(.+)?\.\.(.+)$/g)) {
                //                
                let from = maybeNumber(RegExp.$1), to = maybeNumber(RegExp.$2);
                value = ['between', from, to];
            }
            else {
                value = [op, ...value.split(',').map(maybeNumber)]; //                                            
            }
            return [key, value];
        }
        throw new Error('Url: unknown format for query: ' + q);
    }
    //                                                          
    //                     
    deserializeSearch(urlString) {
        const params = {};
        const parts = urlString ? urlString.split('&') : [];
        parts.forEach(q => {
            if (q.startsWith('f.')) {
                //                             
                try {
                    const [key, value] = this._parseFilterExpression(q);
                    if (!params.f)
                        params.f = {};
                    params.f[key] = value;
                }
                catch (err) {
                    warn(err.message);
                    //                              
                }
            }
            else if (q.match(/^([^=]*)(?:=(.*))?$/)) {
                params[decodeURIComponent(RegExp.$1)] = decodeURIComponent(RegExp.$2 || '');
            }
        });
        const result = _deserialize(this._structure, params);
        return result;
    }
}
